// Plik: src/components/DocumentationClient.tsx
"use client";

import { motion } from "framer-motion";

// --- DANE DOKUMENTÓW ---
const resources = [
  {
    category: "Prawne & Formalności",
    description: "Zabezpiecz swoje interesy przed rozpoczęciem współpracy.",
    items: [
      {
        title: "Wzór Umowy Wdrożeniowej IT",
        desc: "Bezpieczna umowa dla obu stron. Zawiera zapisy o prawach autorskich, harmonogramie i karach umownych.",
        format: "DOCX",
        size: "9.8 KB", // Zaktualizowano na podstawie screena
        popular: true,
        fileUrl: "/documents/UMOWA O DZIEŁO I PRZENIESIENIE PRAW AUTORSKICH (IT).docx",
        icon: (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
        )
      },
      {
        title: "Umowa o Poufności (NDA)",
        desc: "Chroń swój pomysł na aplikację. Gotowy wzór do podpisania przed pierwszą rozmową z software housem.",
        format: "PDF",
        size: "78.8 KB", // Zaktualizowano na podstawie screena
        popular: false,
        fileUrl: "/documents/UMOWA O ZACHOWANIU POUFNOŚCI (NDA).pdf",
        icon: (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
        )
      },
      {
        title: "Wzór Polityki Prywatności (RODO)",
        desc: "Niezbędny dokument na każdą stronę WWW zbierającą dane (formularze, cookies).",
        format: "DOCX",
        size: "9.3 KB", // Zaktualizowano na podstawie screena
        popular: false,
        fileUrl: "/documents/POLITYKA PRYWATNOŚCI SERWISU WEBPOL.EU.docx",
        icon: (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
        )
      }
    ]
  },
  {
    category: "Strategia & Planowanie",
    description: "Nie zaczynaj projektu bez planu. Te szablony oszczędzą Twój czas.",
    items: [
      {
        title: "Brief Projektowy WWW",
        desc: "Lista 40 pytań, na które musisz sobie odpowiedzieć, zanim zlecisz budowę strony agencji.",
        format: "PDF",
        size: "77.2 KB", // Zaktualizowano na podstawie screena
        popular: true,
        fileUrl: "/documents/Brief Projektowy WWW 40 pytań.pdf",
        icon: (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="12 2 2 7 12 12 22 7 12 2"></polygon><polyline points="2 17 12 22 22 17"></polyline><polyline points="2 12 12 17 22 12"></polyline></svg>
        )
      },
      {
        title: "Szablon Buyer Persona",
        desc: "Arkusz do zdefiniowania idealnego klienta. Kluczowy przy planowaniu treści na bloga.",
        format: "PDF",
        size: "100 KB", // Zaktualizowano na podstawie screena
        popular: false,
        fileUrl: "/documents/_SZABLON BUYER PERSONA.pdf",
        icon: (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
        )
      },
      {
        title: "Checklista SEO: Audyt Zero",
        desc: "Prosta lista kontrolna do samodzielnego sprawdzenia, czy Twoja strona jest widoczna dla Google.",
        format: "PDF",
        size: "104 KB", // Zaktualizowano na podstawie screena
        popular: false,
        fileUrl: "/documents/CHECKLISTA SEO_ AUDYT ZERO.pdf",
        icon: (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
        )
      }
    ]
  }
];

// Grid Pattern (tło)
const GridPattern = () => (
  <div className="absolute inset-0 w-full h-full opacity-[0.03] pointer-events-none" 
       style={{ backgroundImage: 'linear-gradient(#000 1px, transparent 1px), linear-gradient(90deg, #000 1px, transparent 1px)', backgroundSize: '40px 40px' }}>
  </div>
);

export default function DocumentationClient() {
  return (
    <main className="bg-[#F7F7F8] w-full min-h-screen relative selection:bg-blue-200 font-sans text-gray-900">

      {/* --- HERO SECTION --- */}
      <section className="pt-32 pb-16 lg:pt-48 lg:pb-24 px-6 relative overflow-hidden bg-white border-b border-gray-200">
        <GridPattern />
        <div className="mx-auto max-w-[1250px] relative z-10 text-center">
             <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-blue-100 bg-blue-50 text-blue-600 text-xs font-bold uppercase tracking-widest mb-6">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                Strefa Wiedzy
            </div>
            <h1 className="text-4xl lg:text-6xl font-bold tracking-tight text-gray-900 mb-6">
                Niezbędnik <span className="text-blue-600">Przedsiębiorcy.</span>
            </h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
                Nie wyważaj otwartych drzwi. Udostępniamy sprawdzone szablony umów, briefy i checklisty, z których sami korzystamy w codziennej pracy. Za darmo.
            </p>
        </div>
      </section>

      {/* --- LISTA DOKUMENTÓW --- */}
      <div className="mx-auto max-w-[1250px] px-6 py-20">
          
          {resources.map((category, idx) => (
              <div key={idx} className="mb-20 last:mb-0">
                  {/* Nagłówek Kategorii */}
                  <div className="mb-10 border-l-4 border-blue-600 pl-6">
                      <h2 className="text-2xl font-bold text-gray-900">{category.category}</h2>
                      <p className="text-gray-500 mt-2">{category.description}</p>
                  </div>

                  {/* Grid Kart */}
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                      {category.items.map((item, itemIdx) => (
                          <motion.div 
                            key={itemIdx}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: itemIdx * 0.1 }}
                            className="group bg-white rounded-2xl border border-gray-200 p-6 shadow-sm hover:shadow-xl hover:border-blue-200 transition-all duration-300 relative"
                          >
                              {/* Badge Popularne */}
                              {item.popular && (
                                  <div className="absolute top-4 right-4 bg-blue-100 text-blue-700 text-[10px] font-bold px-2 py-1 rounded-full uppercase tracking-wide">
                                      Popularne
                                  </div>
                              )}

                              {/* Ikona */}
                              <div className="w-12 h-12 rounded-xl bg-gray-50 text-gray-600 flex items-center justify-center mb-6 group-hover:bg-blue-600 group-hover:text-white transition-colors">
                                  {item.icon}
                              </div>

                              {/* Treść */}
                              <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors">
                                  {item.title}
                              </h3>
                              <p className="text-sm text-gray-500 mb-6 leading-relaxed">
                                  {item.desc}
                              </p>

                              {/* Footer Karty */}
                              <div className="flex items-center justify-between mt-auto pt-6 border-t border-gray-100">
                                  <div className="flex items-center gap-3">
                                      {/* Ikona formatu */}
                                      <div className={`text-[10px] font-bold px-2 py-1 rounded uppercase ${
                                          item.format === 'PDF' ? 'bg-red-100 text-red-600' : 
                                          item.format === 'XLSX' ? 'bg-green-100 text-green-600' : 
                                          'bg-blue-100 text-blue-600'
                                      }`}>
                                          {item.format}
                                      </div>
                                      <span className="text-xs text-gray-400 font-mono">{item.size}</span>
                                  </div>
                                  
                                  {/* PRZYCISK POBIERANIA */}
                                  <a 
                                    href={item.fileUrl} 
                                    download 
                                    className="flex items-center gap-2 text-sm font-bold text-gray-900 hover:text-blue-600 transition-colors cursor-pointer"
                                  >
                                      Pobierz
                                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                                  </a>
                              </div>
                          </motion.div>
                      ))}
                  </div>
              </div>
          ))}

      </div>

      {/* --- CTA: POTRZEBUJESZ POMOCY? --- */}
      <section className="py-20 bg-white border-t border-gray-100">
        <div className="mx-auto max-w-4xl px-6 text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Dokumenty to dopiero początek.</h2>
            <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
                Pobranie briefu to pierwszy krok. Jeśli potrzebujesz pomocy w jego wypełnieniu lub chcesz skonsultować swój projekt z ekspertem, jesteśmy do dyspozycji.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
                <a href="/kontakt" className="rounded-full bg-black px-8 py-4 text-white font-bold hover:bg-gray-800 transition shadow-lg">
                    Umów bezpłatną konsultację
                </a>
            </div>
        </div>
      </section>

      
    </main>
  );
}